<button mat-button class="close-icon" [mat-dialog-close]="false">
  <mat-icon>close</mat-icon>
</button>
<h1 mat-dialog-title class="text-center">{{ data.title || "" }}</h1>

<div *ngIf="data.message" class="text-center alert alert-warning modal-message">
  <div>{{ data.message }}</div>
</div>

<mat-dialog-content>
  <ng-template content></ng-template>
</mat-dialog-content>

<div *ngIf="!data.buttons?.hide" mat-dialog-actions class="d-flex justify-content-center">
  <button
    *ngIf="!data.buttons?.cancel?.hide"
    mat-button
    [mat-dialog-close]="false"
    cdkFocusInitial
    mat-stroked-button
    color="warn"
  >
    {{ data.buttons?.cancel?.name || this.config.buttons.cancel.name }}
  </button>
  <button
    *ngIf="!data.buttons?.submit?.hide"
    mat-raised-button
    color="warn"
    [disabled]="data.buttons?.submit?.disabled ? data.buttons?.submit?.disabled(componentInstance) : onDisable()"
    (click)="data.buttons?.submit?.action(componentInstance) || onSubmit($event)"
  >
    {{ data.buttons?.submit?.name || this.config.buttons.submit.name }}
  </button>
</div>
